import React from 'react'
import { ThemeProvider } from '@mui/material/styles'
import mainTheme from '@/components/themes/mainTheme'
import Routes from '@/components/routes/Routes'
import { BrowserRouter } from 'react-router-dom'
import './css/embla.css'

const App: React.FC = () => {
  const loader = document.getElementById('loader')
  loader.classList.add('loaded')

  setTimeout(() => {
    loader.remove()
  }, 1000)

  return (
    <>
      <React.StrictMode>
        <BrowserRouter>
          <React.Suspense fallback={<></>}>
            <ThemeProvider theme={mainTheme}>
              <Routes />
            </ThemeProvider>
          </React.Suspense>
        </BrowserRouter>
      </React.StrictMode>
    </>
  )
}

export default App
